export const featuresData = [
  {
    id: 1,
    title: 'My education',
    features: [
      "Master's Degree in Electronic Industry",
      'Frontend Development',
      '...many days of practice and experimenting',
    ],
  },
  {
    id: 2,
    title: 'What I know',
    features: [
      'JavaScript,TypeScript',
      'React, Redux',
      'HTML,CSS,Sass(SCSS)',
      'Bootstrap,Bulma',
      'Fetch, Axios, REST API',
      'Figma',
      'Git/GitHub, VS Code, Chrome Developer Tools (incl. React)',
      'Basic OOP understanding',
      'Jira, Trello, Сonfluence (Atlassian Products)',
    ],
  },
  {
    id: 3,
    title: 'My future way',
    features: [
      'Backend Development',
      'UX/UI Design',
      'DevOps',
    ],
  },
];
